import { construct } from '@aximario/json-tree';

export default class {
  // 用于用户模式，
  async getOrgByUser() {
    const res = await this.http({ cmd: 'common/getOrganizationNodeByUser' });
    const list = res.data;
    // 创建树
    const organizationList = construct(list, {
      id: 'organizationId',
      pid: 'parentId',
      children: 'children'
    });
    this.organizationList = organizationList;
    this.organizationListFlat = list;
  }

  // 用于获取所有公司,普通模式
  async getAllCompany() {
    const res = await this.http({ cmd: 'device/companyList' });
    const list = res.data;
    // 转换字段
    list.map(i => {
      i.organizationId = i.guid;
      i.organizationCode = i.resourceCode;
      i.organizationName = i.resourceName;
      i.organizationPerson = i.resourcePerson;
      i.organizationPhone = i.resourcePhone;
      i.orgnizationAddress = i.resourceAddress;
    });
    list.sort((a, b) => {
      return new Date(a.createTime).getTime() - new Date(b.createTime).getTime();
    });
    // 创建树
    this.organizationList = construct(list, {
      id: 'organizationId',
      pid: 'parentId',
      children: 'children'
    });
    this.organizationListFlat = list;
  }

  initModelValue() {
    // 搜索列表，进行足组件值的回显，如果没有this.value,不更新回显
    if (!this.value) {
      return;
    }
    this.modelValue = this.organizationListFlat.find(i => i.organizationId === (this.value || this.value.organizationId));
  }
}
